export default __webpack_public_path__ + "static/media/Capture3.7c317547.PNG";